import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { MIXPANEL_APP_NAME } from 'constants/mixpanel'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { getOperationCode } from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

export const getTransportOptionValue = (transportation) => {
  switch (transportation) {
    case 'included':
      return 'Transport included'
    case 'none':
      return 'Without transport'
    case 'all':
    default:
      return 'All offers'
  }
}

const mapStateToEvent = (state, action) => (
  {
    'Click Name': 'Transportation pills',
    'Operation Code': getOperationCode(state),
    'Transport option': getTransportOptionValue(action.payload.selectedTransportation),
    'Type': MIXPANEL_APP_NAME
  }
)

const clickTransportationPillsTrackingEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.filters.SELECT_TRANSPORTATION),
  tap(action => {
    const eventName = 'Click'

    track(eventName, mapStateToEvent(state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickTransportationPillsTrackingEpic
